export default function EmotionalCTA() {
  const scrollTo = () => {
    const el = document.getElementById('contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <div className="relative rounded-2xl overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Professional%20diverse%20team%20collaborating%20in%20bright%20modern%20office%20with%20warm%20natural%20daylight%2C%20confident%20and%20focused%20atmosphere%2C%20creative%20brainstorming%20energy%2C%20soft%20cream%20and%20warm%20neutral%20tones%2C%20clean%20elegant%20contemporary%20aesthetic%2C%20abstract%20professional%20business%20environment%2C%20teamwork%20and%20synergy%20concept%2C%20no%20text%20no%20logos%20no%20branding&width=1600&height=800&seq=soft-skills-emotional-cta-2026&orientation=landscape"
              alt=""
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/75 to-black/65"></div>
          </div>

          <div className="relative z-10 p-8 md:p-16">
            <h2 className="text-2xl md:text-4xl font-bold text-white mb-6 leading-tight">
              Soft Skills — это то, что отличает среднюю компанию от лидера рынка
            </h2>
            <div className="space-y-4 mb-10 max-w-3xl">
              <p className="text-base md:text-lg text-white/85 leading-relaxed">
                Можно нанять лучших специалистов, купить самое современное оборудование, внедрить CRM и настроить маркетинг. Но если ваши сотрудники не умеют общаться друг с другом, не слышат клиентов, избегают ответственности и боятся изменений — весь этот фундамент рухнет.
              </p>
              <p className="text-base md:text-lg text-white/85 leading-relaxed">
                Именно поэтому <strong className="text-white">развитие Soft Skills</strong> — одна из самых быстро окупаемых инвестиций. Она влияет на всё: от атмосферы в офисе до годовой выручки.
              </p>
              <p className="text-base md:text-lg text-white font-semibold leading-relaxed">
                Если вы хотите, чтобы ваша команда не просто работала, а достигала выдающихся результатов, — начните с диагностики Soft Skills. Мы разработаем программу именно под ваши задачи.
              </p>
            </div>

            <button
              onClick={scrollTo}
              className="bg-teal-600 text-white px-10 py-5 rounded-lg text-lg font-semibold hover:bg-teal-500 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-3"
            >
              Заказать тренинг по Soft Skills
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}